<template>
    <div class="class-page">
        <!-- 查询筛选卡片 -->
        <el-card shadow="always" class="filter-card">
            <div slot="header" class="card-header">
                <div class="card-header-left">
                    <i class="el-icon-school"></i>
                    <span>班级管理</span>
                    <el-divider direction="vertical"></el-divider>
                    <span class="header-sub">筛选条件</span>
                </div>
            </div>
            <el-form :inline="true" :model="query" class="filter-form">
                <el-form-item label="所属年级">
                    <el-select clearable v-model="query.gradeId" placeholder="全部年级" style="width: 160px">
                        <el-option v-for="item in gradeList" :key="item.id" :label="item.gradeName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="班级名称">
                    <el-input clearable v-model="query.className" placeholder="请输入班级名称" style="width: 180px"></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select clearable v-model="query.status" placeholder="全部状态" style="width: 120px">
                        <el-option label="启用" :value="1"></el-option>
                        <el-option label="禁用" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 表格卡片 -->
        <el-card shadow="always" class="table-card">
            <div slot="header" class="card-header">
                <div class="card-header-left">
                    <span>数据列表</span>
                    <span class="total-badge">共 <b>{{ total }}</b> 条</span>
                </div>
                <div class="card-header-right">
                    <el-button type="success" icon="el-icon-files" @click="openBatchDialog">批量新增</el-button>
                    <el-button type="primary" icon="el-icon-plus" @click="btnInsert(null)">新增班级</el-button>
                </div>
            </div>
            <el-table
                :data="list"
                border
                stripe
                v-loading="tableLoading"
                element-loading-text="加载中..."
                style="width: 100%">
                <el-table-column type="index" label="序号" width="100" align="center"/>
                <el-table-column prop="gradeName" label="所属年级" show-overflow-tooltip/>
                <el-table-column prop="className" label="班级名称" show-overflow-tooltip/>
<!--                <el-table-column prop="schoolYear" label="学年" width="120" align="center">-->
<!--                    <template slot-scope="scope">-->
<!--                        <span>{{ scope.row.schoolYear || '-' }}</span>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column prop="description" label="描述" min-width="150" show-overflow-tooltip>-->
<!--                    <template slot-scope="scope">-->
<!--                        <span>{{ scope.row.description || '-' }}</span>-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column prop="sort" label="排序" align="center"/>
                <el-table-column prop="status" label="状态" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small" effect="plain">
                            {{ scope.row.status === 1 ? '启用' : '禁用' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" align="center"/>
                <el-table-column align="center" label="操作" width="180" fixed="right">
                    <template slot-scope="scope">
                        <div class="action-btns">
                            <el-button type="primary" size="mini" icon="el-icon-edit" @click="btnInsert(scope.row)">编辑</el-button>
                            <el-button type="danger" size="mini" icon="el-icon-delete" @click="btnDelete(scope.row.id)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrapper" v-if="total > 0">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="query.currentPage"
                    :page-size="query.pageSize"
                    :total="total">
                </el-pagination>
            </div>
        </el-card>

        <!-- 新增/编辑对话框 -->
        <el-dialog
            :close-on-click-modal="false"
            :visible.sync="dialogVisible"
            width="600px"
            top="8vh"
            :show-close="false"
            @close="closeDialog"
            custom-class="class-dialog">
            <div slot="title" class="batch-header">
                <div class="batch-header-left">
                    <div class="batch-header-icon"><i class="el-icon-notebook-2"></i></div>
                    <div>
                        <div class="batch-header-title">{{ dialogTitle }}</div>
                        <div class="batch-header-desc">填写班级基础信息，带 * 为必填项</div>
                    </div>
                </div>
                <i class="el-icon-close batch-header-close" @click="dialogVisible = false"></i>
            </div>
            <el-form :model="formData" ref="formData" :rules="rules" label-width="80px">
                <el-form-item label="所属年级" prop="gradeId">
                    <el-select v-model="formData.gradeId" placeholder="请选择年级" style="width: 100%">
                        <el-option v-for="item in gradeList" :key="item.id" :label="item.gradeName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="班级名称" prop="className">
                    <el-input v-model="formData.className" maxlength="30" placeholder="例如：七年级1班"></el-input>
                </el-form-item>
                <el-form-item label="学年" prop="schoolYear">
                    <el-input v-model="formData.schoolYear" maxlength="20" placeholder="例如：2025-2026"></el-input>
                </el-form-item>
                <el-form-item label="描述" prop="description">
                    <el-input type="textarea" v-model="formData.description" maxlength="200" placeholder="请输入描述" :rows="3"></el-input>
                </el-form-item>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="排序" prop="sort">
                            <el-input-number v-model="formData.sort" :min="0" :max="9999" controls-position="right" style="width: 100%"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="状态" prop="status">
                            <el-radio-group v-model="formData.status">
                                <el-radio :label="1">启用</el-radio>
                                <el-radio :label="0">禁用</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm" :loading="submitLoading">确定</el-button>
            </div>
        </el-dialog>

        <!-- 批量新增对话框 -->
        <el-dialog
            :visible.sync="batchDialogVisible"
            width="840px"
            top="6vh"
            :close-on-click-modal="false"
            :show-close="false"
            @close="closeBatchDialog"
            custom-class="batch-class-dialog">
            <!-- 自定义头部 -->
            <div slot="title" class="batch-header">
                <div class="batch-header-left">
                    <div class="batch-header-icon"><i class="el-icon-notebook-2"></i></div>
                    <div>
                        <div class="batch-header-title">批量新增班级</div>
                        <div class="batch-header-desc">选年级 · 设数量 · 一键生成，已存在的班级自动跳过</div>
                    </div>
                </div>
                <i class="el-icon-close batch-header-close" @click="batchDialogVisible = false"></i>
            </div>

            <!-- 快捷操作条：一步完成最常见场景 -->
            <div class="batch-quickbar">
                <div class="quick-item">
                    <span class="quick-label">快速选择</span>
                    <el-button size="mini" :type="isAllGradeChecked ? 'primary' : 'default'" @click="toggleAllGrades">
                        {{ isAllGradeChecked ? '取消全选' : '全部年级' }}
                    </el-button>
                    <el-button
                        v-for="sec in stageSections"
                        :key="sec.stage"
                        size="mini"
                        :type="isStageCheckedAll(sec.stage) ? 'primary' : 'default'"
                        @click="toggleStageAll(sec.stage, !isStageCheckedAll(sec.stage))">{{ sec.label }}</el-button>
                </div>
                <div class="quick-item">
                    <span class="quick-label">每级班数</span>
                    <el-input-number v-model="unifiedCount" :min="1" :max="30" size="mini" controls-position="right" style="width: 100px"></el-input-number>
                    <el-button size="mini" type="primary" plain @click="applyUnifiedCount">应用全部</el-button>
                </div>
                <div class="quick-item">
                    <span class="quick-label">名称风格</span>
                    <el-radio-group v-model="batchStyle" size="mini">
                        <el-radio-button label="full">三年级1班</el-radio-button>
                        <el-radio-button label="paren">三(1)班</el-radio-button>
                        <el-radio-button label="num">1班</el-radio-button>
                    </el-radio-group>
                </div>
            </div>

            <!-- 年级分段多选 -->
            <div class="batch-sections">
                <div class="batch-section" v-for="sec in stageSections" :key="sec.stage">
                    <div class="batch-section-head">
                        <span class="batch-section-title" :class="'stage-' + sec.stage">
                            <i class="batch-stage-dot"></i>{{ sec.label }}
                        </span>
                        <el-checkbox
                            :indeterminate="isStageIndeterminate(sec.stage)"
                            :value="isStageCheckedAll(sec.stage)"
                            @change="(val) => toggleStageAll(sec.stage, val)">全选</el-checkbox>
                    </div>
                    <div class="batch-grade-grid">
                        <div
                            v-for="item in sec.items"
                            :key="item.id"
                            class="batch-grade-card"
                            :class="{ active: selectedGradeIds.includes(item.id) }"
                            @click="toggleGrade(item)">
                            <i class="el-icon-check batch-grade-check"></i>
                            <span class="batch-grade-name">{{ item.gradeName }}</span>
                            <div class="batch-grade-count" @click.stop v-if="selectedGradeIds.includes(item.id)">
                                <span>班级数</span>
                                <el-input-number v-model="countMap[item.id]" :min="1" :max="30" controls-position="right" size="mini"></el-input-number>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 预览区 -->
            <div class="batch-preview" v-if="previewList.length > 0">
                <div class="batch-preview-head">
                    <span class="preview-title">名称预览</span>
                    <span class="preview-count">共 <b>{{ previewList.length }}</b> 个，可直接修改名称</span>
                </div>
                <div class="batch-preview-list">
                    <div class="batch-preview-item" v-for="(p, idx) in previewList" :key="idx">
                        <span class="preview-grade">{{ p.gradeName }}</span>
                        <el-input v-model="p.className" size="mini" class="preview-input"></el-input>
                        <i class="el-icon-close preview-del" @click="removePreview(idx)" title="移除"></i>
                    </div>
                </div>
            </div>
            <div class="batch-empty" v-else>
                <i class="el-icon-folder-opened"></i>
                <p>点击上方「全部年级」或单个年级卡片，即可自动生成班级</p>
            </div>

            <div slot="footer" class="batch-footer">
                <span class="batch-footer-tip" v-if="previewList.length > 0">
                    将创建 <b>{{ previewList.length }}</b> 个班级
                </span>
                <span v-else></span>
                <div>
                    <el-button @click="batchDialogVisible = false">取消</el-button>
                    <el-button type="primary" icon="el-icon-check" @click="submitBatch" :loading="batchLoading" :disabled="previewList.length === 0">确认创建</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { reqClassPage, reqClassInsert, reqClassUpdate, reqClassDelete, reqClassBatchInsert } from '@/api/education/class'
import { reqGradePage } from '@/api/education/grade'

export default {
    name: 'Class',
    data() {
        return {
            list: [],
            total: 0,
            gradeList: [],
            tableLoading: false,
            submitLoading: false,
            query: {
                currentPage: 1,
                pageSize: 10,
                className: '',
                gradeId: null,
                status: null
            },
            dialogVisible: false,
            dialogTitle: '',
            // 批量新增相关
            batchDialogVisible: false,
            batchLoading: false,
            batchStyle: 'full',
            selectedGradeIds: [],
            countMap: {},
            unifiedCount: 2,
            formData: {
                id: null,
                className: '',
                gradeId: null,
                schoolYear: '',
                description: '',
                sort: 0,
                status: 1
            },
            rules: {
                className: [
                    { required: true, message: '请输入班级名称', trigger: 'blur' },
                    { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
                ],
                gradeId: [
                    { required: true, message: '请选择所属年级', trigger: 'change' }
                ]
            }
        }
    },
    created() {
        this.initPage()
    },
    computed: {
        // 年级按学段分组（小学1/初中2/高中3）
        stageSections() {
            const order = [1, 2, 3]
            return order.map(stage => ({
                stage,
                label: { 1: '小学', 2: '初中', 3: '高中' }[stage],
                items: this.gradeList.filter(item => item.stage === stage)
            })).filter(sec => sec.items.length > 0)
        },
        // 是否已全选所有年级
        isAllGradeChecked() {
            return this.gradeList.length > 0 && this.selectedGradeIds.length === this.gradeList.length
        },
        // 预览班级列表（根据选中年级 + 数量 + 风格实时生成，可编辑）
        previewList() {
            const list = []
            this.selectedGradeIds.forEach(gradeId => {
                const grade = this.gradeList.find(g => g.id === gradeId)
                if (!grade) return
                const count = this.countMap[gradeId] || 1
                for (let i = 1; i <= count; i++) {
                    list.push({
                        gradeId: grade.id,
                        gradeName: grade.gradeName,
                        className: this.buildClassName(grade.gradeName, i)
                    })
                }
            })
            return list
        }
    },
    methods: {
        async initPage() {
            await this.loadGradeList()
            this.load()
        },
        async loadGradeList() {
            try {
                const data = await reqGradePage({ currentPage: 1, pageSize: 100 })
                this.gradeList = data.records || []
            } catch (e) {
                console.error('加载年级列表失败:', e)
            }
        },
        async load() {
            this.tableLoading = true
            try {
                const data = await reqClassPage(this.query)
                this.list = data.records || []
                this.total = data.total || 0
            } catch (e) {
                this.$message.error('加载班级列表失败')
                console.error(e)
            } finally {
                this.tableLoading = false
            }
        },
        handleSearch() {
            this.query.currentPage = 1
            this.load()
        },
        handleReset() {
            this.query = {
                currentPage: 1,
                pageSize: 10,
                className: '',
                gradeId: null,
                status: null
            }
            this.load()
        },
        currentChange(num) {
            this.query.currentPage = num
            this.load()
        },
        sizeChange(size) {
            this.query.pageSize = size
            this.query.currentPage = 1
            this.load()
        },
        btnInsert(row) {
            if (row) {
                this.dialogTitle = '编辑班级'
                this.formData = {
                    id: row.id,
                    className: row.className || '',
                    gradeId: row.gradeId || null,
                    schoolYear: row.schoolYear || '',
                    description: row.description || '',
                    sort: row.sort || 0,
                    status: row.status != null ? row.status : 1
                }
            } else {
                this.dialogTitle = '新增班级'
                this.formData = {
                    id: null,
                    className: '',
                    gradeId: null,
                    schoolYear: '',
                    description: '',
                    sort: 0,
                    status: 1
                }
            }
            this.$nextTick(() => {
                if (this.$refs.formData) {
                    this.$refs.formData.clearValidate()
                }
            })
            this.dialogVisible = true
        },
        closeDialog() {
            this.$refs.formData && this.$refs.formData.clearValidate()
        },
        async btnDelete(id) {
            try {
                await this.$confirm('确定要删除该班级吗？删除后不可恢复。', '删除确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                await reqClassDelete(id)
                this.$message.success('删除成功')
                this.load()
            } catch (e) {
                if (e !== 'cancel') {
                }
            }
        },
        submitForm() {
            this.$refs.formData.validate(async valid => {
                if (!valid) return

                this.submitLoading = true
                try {
                    if (this.formData.id) {
                        await reqClassUpdate(this.formData)
                    } else {
                        await reqClassInsert(this.formData)
                    }
                    this.$message.success('操作成功')
                    this.dialogVisible = false
                    this.load()
                } catch (e) {
                    this.$message.error(e.message || '操作失败')
                } finally {
                    this.submitLoading = false
                }
            })
        },
        // 根据风格与序号生成班级名
        buildClassName(gradeName, index) {
            if (this.batchStyle === 'full') {
                return gradeName + index + '班'
            } else if (this.batchStyle === 'paren') {
                // 三(1)班：提取年级名中数字前的汉字部分 + (序号)
                const cn = gradeName.replace(/[0-9]/g, '')
                return cn + '(' + index + ')班'
            } else {
                // 3班：仅序号
                return index + '班'
            }
        },
        // 批量新增相关方法
        openBatchDialog() {
            this.batchStyle = 'full'
            this.unifiedCount = 2
            // 默认全选所有年级，减少用户操作
            this.selectedGradeIds = this.gradeList.map(g => g.id)
            this.countMap = {}
            this.gradeList.forEach(g => this.$set(this.countMap, g.id, this.unifiedCount || 1))
            this.batchDialogVisible = true
        },
        // 一键全选/取消全部年级
        toggleAllGrades() {
            if (this.isAllGradeChecked) {
                this.selectedGradeIds = []
                this.countMap = {}
            } else {
                this.selectedGradeIds = this.gradeList.map(g => g.id)
                this.gradeList.forEach(g => this.$set(this.countMap, g.id, this.unifiedCount || 1))
            }
        },
        // 把统一数量应用到所有已选年级（未选则自动全选）
        applyUnifiedCount() {
            const count = this.unifiedCount || 1
            if (this.selectedGradeIds.length === 0) {
                this.selectedGradeIds = this.gradeList.map(g => g.id)
            }
            this.selectedGradeIds.forEach(id => this.$set(this.countMap, id, count))
        },
        closeBatchDialog() {
            this.batchDialogVisible = false
        },
        toggleGrade(item) {
            const idx = this.selectedGradeIds.indexOf(item.id)
            if (idx >= 0) {
                this.selectedGradeIds.splice(idx, 1)
                delete this.countMap[item.id]
            } else {
                this.selectedGradeIds.push(item.id)
                // 直接沿用顶部统一数量，减少用户反复调整
                this.$set(this.countMap, item.id, this.unifiedCount || 1)
            }
        },
        isStageCheckedAll(stage) {
            const ids = this.stageSections.find(s => s.stage === stage).items.map(i => i.id)
            return ids.length > 0 && ids.every(id => this.selectedGradeIds.includes(id))
        },
        isStageIndeterminate(stage) {
            const ids = this.stageSections.find(s => s.stage === stage).items.map(i => i.id)
            const sel = ids.filter(id => this.selectedGradeIds.includes(id))
            return sel.length > 0 && !this.isStageCheckedAll(stage)
        },
        toggleStageAll(stage, val) {
            const ids = this.stageSections.find(s => s.stage === stage).items.map(i => i.id)
            if (val) {
                ids.forEach(id => {
                    if (!this.selectedGradeIds.includes(id)) {
                        this.selectedGradeIds.push(id)
                        this.$set(this.countMap, id, this.unifiedCount || 1)
                    }
                })
            } else {
                this.selectedGradeIds = this.selectedGradeIds.filter(id => !ids.includes(id))
                ids.forEach(id => delete this.countMap[id])
            }
        },
        removePreview(idx) {
            // 从预览移除：找到对应 gradeId，减少该年级 count
            const p = this.previewList[idx]
            if (!p) return
            const cur = this.countMap[p.gradeId] || 1
            if (cur > 1) {
                this.countMap[p.gradeId] = cur - 1
            } else {
                this.toggleGrade(this.gradeList.find(g => g.id === p.gradeId))
            }
        },
        submitBatch() {
            if (this.previewList.length === 0) {
                this.$message.warning('请至少选择一个年级')
                return
            }
            // 按最终编辑后的名称组装提交数据
            const payload = this.previewList.map(p => ({
                gradeId: p.gradeId,
                className: p.className,
                status: 1,
                sort: 0
            }))
            this.batchLoading = true
            reqClassBatchInsert(payload)
                .then(() => {
                    this.$message.success('批量新增成功')
                    this.batchDialogVisible = false
                    this.load()
                })
                .catch(e => {
                    this.$message.error(e.message || '批量新增失败')
                })
                .finally(() => {
                    this.batchLoading = false
                })
        }
    }
}
</script>

<style scoped lang="scss">
.class-page {
    padding: 0;

    .filter-card {
        margin: 10px 15px;

        ::v-deep .el-card__header {
            padding: 16px 20px;
            background: #fafafa;
            border-bottom: 1px solid #ebeef5;
        }
    }

    .table-card {
        margin: 10px 15px;

        ::v-deep .el-card__header {
            padding: 14px 20px;
            background: #fafafa;
            border-bottom: 1px solid #ebeef5;
        }
    }

    .card-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .card-header-left {
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 15px;
            font-weight: 600;
            color: #303133;

            i {
                font-size: 18px;
                color: #409eff;
            }

            .header-sub {
                font-size: 13px;
                font-weight: 500;
                color: #909399;
            }

            .total-badge {
                font-size: 13px;
                font-weight: 400;
                color: #909399;
                margin-left: 8px;

                b {
                    color: #409eff;
                    font-size: 16px;
                    font-weight: 600;
                }
            }
        }

        .card-header-right {
            display: flex;
            align-items: center;
            gap: 10px;
        }
    }

    .filter-form {
        padding: 4px 0 0;

        ::v-deep .el-form-item {
            margin-bottom: 8px;
        }
    }

    .pagination-wrapper {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    }

    .action-btns {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        white-space: nowrap;

        .el-button + .el-button {
            margin-left: 0;
        }
    }

    ::v-deep .el-divider--vertical {
        height: 1.2em;
        margin: 0 4px;
    }

    ::v-deep .el-table {
        th {
            background: #fafafa;
            color: #606266;
            font-weight: 600;
            font-size: 13px;
        }

        td {
            font-size: 13px;
        }

        .el-tag--plain {
            font-weight: 500;
        }
    }

    ::v-deep .el-dialog {
        border-radius: 6px;
        overflow: hidden;

        .el-dialog__header {
            padding: 16px 24px;
            border-bottom: 1px solid #ebeef5;

            .el-dialog__title {
                font-size: 16px;
                font-weight: 600;
                color: #303133;
            }
        }

        .el-dialog__body {
            padding: 24px 30px 8px;
        }

        .el-dialog__footer {
            padding: 14px 30px;
            border-top: 1px solid #ebeef5;
        }
    }

    // ===== 批量弹窗头部 =====
    .batch-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .batch-header-left {
            display: flex;
            align-items: center;
            gap: 12px;
        }

        .batch-header-icon {
            width: 38px;
            height: 38px;
            border-radius: 10px;
            background: rgba(255, 255, 255, 0.22);
            display: flex;
            align-items: center;
            justify-content: center;

            i {
                font-size: 20px;
                color: #fff;
            }
        }

        .batch-header-title {
            font-size: 16px;
            font-weight: 600;
            color: #fff;
            line-height: 1.4;
        }

        .batch-header-desc {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.85);
            margin-top: 2px;
        }

        .batch-header-close {
            font-size: 18px;
            color: rgba(255, 255, 255, 0.85);
            cursor: pointer;
            transition: all 0.2s;

            &:hover {
                color: #fff;
                transform: rotate(90deg);
            }
        }
    }

    // ===== 快捷操作条 =====
    .batch-quickbar {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 10px 22px;
        padding: 12px 16px;
        margin-bottom: 16px;
        background: linear-gradient(135deg, #f3faf7 0%, #f7fbf9 100%);
        border: 1px solid #e3f1ec;
        border-radius: 10px;

        .quick-item {
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .quick-label {
            font-size: 13px;
            color: #5a6b64;
            font-weight: 500;
            white-space: nowrap;
        }

        ::v-deep .el-button--mini {
            padding: 6px 12px;
            border-radius: 6px;
        }
    }

    .batch-sections {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .batch-section {
        & + .batch-section {
            padding-top: 16px;
            border-top: 1px dashed #ebeef5;
        }

        .batch-section-head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 12px;
        }

        .batch-section-title {
            display: inline-flex;
            align-items: center;
            font-size: 14px;
            font-weight: 600;

            .batch-stage-dot {
                width: 8px;
                height: 8px;
                border-radius: 50%;
                margin-right: 8px;
            }

            &.stage-1 {
                color: #67c23a;
                .batch-stage-dot { background: #67c23a; }
            }
            &.stage-2 {
                color: #e6a23c;
                .batch-stage-dot { background: #e6a23c; }
            }
            &.stage-3 {
                color: #909399;
                .batch-stage-dot { background: #909399; }
            }
        }
    }

    .batch-grade-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
        gap: 12px;

        .batch-grade-card {
            position: relative;
            display: flex;
            flex-direction: column;
            gap: 8px;
            padding: 12px 14px;
            border: 1px solid #ebeef5;
            border-radius: 10px;
            background: #fff;
            cursor: pointer;
            user-select: none;
            transition: all 0.2s ease;

            &:hover {
                border-color: #b9ddd2;
                box-shadow: 0 2px 10px rgba(46, 139, 116, 0.12);
            }

            .batch-grade-check {
                position: absolute;
                top: 10px;
                right: 10px;
                font-size: 14px;
                color: #fff;
                background: #2e8b74;
                border-radius: 50%;
                padding: 2px;
                opacity: 0;
                transform: scale(0.6);
                transition: all 0.2s ease;
            }

            .batch-grade-name {
                font-size: 15px;
                font-weight: 600;
                color: #303133;
            }

            .batch-grade-count {
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 12px;
                color: #909399;

                ::v-deep .el-input-number {
                    width: 96px;

                    .el-input-number__decrease,
                    .el-input-number__increase {
                        background: #f4f4f5;
                    }
                }
            }

            &.active {
                border-color: #2e8b74;
                background: linear-gradient(135deg, #e8f5f0 0%, #f4faf8 100%);
                box-shadow: 0 2px 10px rgba(46, 139, 116, 0.18);

                .batch-grade-check {
                    opacity: 1;
                    transform: scale(1);
                }

                .batch-grade-name {
                    color: #2e8b74;
                }
            }
        }
    }

    .batch-preview {
        margin-top: 18px;
        background: #fafbfc;
        border: 1px solid #eef0f5;
        border-radius: 10px;
        padding: 14px 16px;

        .batch-preview-head {
            display: flex;
            align-items: baseline;
            gap: 10px;
            margin-bottom: 12px;

            .preview-title {
                font-size: 14px;
                font-weight: 600;
                color: #303133;
                position: relative;
                padding-left: 10px;

                &::before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 3px;
                    height: 13px;
                    background: #2e8b74;
                    border-radius: 2px;
                }
            }

            .preview-count {
                font-size: 12px;
                color: #909399;
            }
        }

        .batch-preview-list {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
            max-height: 220px;
            overflow-y: auto;
        }

        .batch-preview-item {
            display: flex;
            align-items: center;
            gap: 6px;
            background: #fff;
            border: 1px solid #ebeef5;
            border-radius: 8px;
            padding: 4px 6px 4px 10px;
            transition: all 0.2s;

            &:hover {
                border-color: #b9ddd2;
                box-shadow: 0 2px 8px rgba(46, 139, 116, 0.1);
            }

            .preview-grade {
                font-size: 12px;
                color: #909399;
                white-space: nowrap;
            }

            .preview-input {
                width: 120px;

                ::v-deep .el-input__inner {
                    height: 28px;
                    line-height: 28px;
                }
            }

            .preview-del {
                color: #c0c4cc;
                cursor: pointer;
                font-size: 14px;
                padding: 2px;
                border-radius: 50%;
                transition: all 0.2s;

                &:hover {
                    color: #fff;
                    background: #f56c6c;
                }
            }
        }
    }

    .batch-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .batch-footer-tip {
            font-size: 13px;
            color: #8a9a93;

            b {
                color: #2e8b74;
                font-size: 16px;
                margin: 0 2px;
            }
        }
    }

    ::v-deep .batch-class-dialog {
        border-radius: 12px;

        .el-dialog__header {
            padding: 16px 22px;
            background: linear-gradient(135deg, #2e8b74 0%, #4fae93 100%);
            border-bottom: none;
        }

        .el-dialog__body {
            padding: 20px 24px 8px;
            max-height: 64vh;
            overflow-y: auto;
        }

        .el-dialog__footer {
            padding: 12px 24px;
            border-top: 1px solid #ebeef5;
            background: #fafbfc;
        }

        ::v-deep .el-button--primary {
            background-color: #2e8b74;
            border-color: #2e8b74;

            &:hover, &:focus {
                background-color: #3aa98a;
                border-color: #3aa98a;
            }

            &.is-disabled {
                background-color: #a9d3c8;
                border-color: #a9d3c8;
            }
        }
    }

    ::v-deep .class-dialog {
        border-radius: 12px;

        .el-dialog__header {
            padding: 16px 22px;
            background: linear-gradient(135deg, #2e8b74 0%, #4fae93 100%);
            border-bottom: none;

            .el-dialog__title {
                color: #fff;
                font-size: 16px;
                font-weight: 600;
            }

            .el-dialog__headerbtn .el-dialog__close {
                color: rgba(255, 255, 255, 0.85);

                &:hover {
                    color: #fff;
                }
            }
        }

        ::v-deep .el-button--primary {
            background-color: #2e8b74;
            border-color: #2e8b74;

            &:hover, &:focus {
                background-color: #3aa98a;
                border-color: #3aa98a;
            }
        }
    }

    .batch-empty {
        margin-top: 18px;
        text-align: center;
        padding: 30px 0;
        color: #c0c4cc;
        background: #fafbfc;
        border: 1px dashed #e4e7ed;
        border-radius: 10px;

        i {
            font-size: 36px;
            margin-bottom: 8px;
        }

        p {
            margin: 0;
            font-size: 13px;
        }
    }
}

@media screen and (max-width: 768px) {
    .class-page {
        .card-header {
            flex-wrap: wrap;
            gap: 8px;
        }

        .filter-form {
            ::v-deep .el-form--inline .el-form-item {
                display: block;
                width: 100%;
                margin-bottom: 12px;
            }

            ::v-deep .el-form--inline .el-form-item .el-form-item__content {
                width: 100%;
            }

            ::v-deep .el-form--inline .el-form-item .el-form-item__content .el-select,
            ::v-deep .el-form--inline .el-form-item .el-form-item__content .el-input {
                width: 100% !important;
            }
        }

        ::v-deep .el-card__body {
            padding: 12px;
        }

        ::v-deep .el-table {
            overflow-x: auto;
            display: block;
        }

        ::v-deep .el-dialog {
            width: 95% !important;
            margin: 10px auto !important;
        }

        ::v-deep .el-dialog__body {
            padding: 16px;
        }

        ::v-deep .el-dialog__footer {
            padding: 12px 16px;
        }

        ::v-deep .el-pagination {
            white-space: normal;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: 4px;
        }

        ::v-deep .el-pagination .el-pagination__total,
        ::v-deep .el-pagination .el-pagination__sizes {
            margin-right: 0;
        }

        ::v-deep .el-pagination button,
        ::v-deep .el-pagination .el-pager li {
            min-width: 28px;
            height: 28px;
            line-height: 28px;
            font-size: 12px;
        }
    }
}
</style>
